import { Button } from "@chakra-ui/react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "~components/Form/components/Select";

import "./style.scss";
import { CleanFiltersIcon, SearchAdd } from "~misc/icons";
import { Link } from "react-router-dom";
import { FunnelFilterProps } from "./FunnelFilterProps";
import { utils } from "~pages/Funnel/utils";
import useFunnelOptions from "~pages/Funnel/hooks/useFunnelOptions";
import useParametros from "~fetchs/useParametros";

const FunnelFilter = ({ props, filters, setFilters, productsFilter, setObjects, objects }) => {
  const formikRef = useRef();
  const { orders, negotiations, funilObraGruposProduto, funilObraProdutos } = useFunnelOptions({ formikRef });
  
  const [hideSku, setHideSku] = useState(true);

  const { getBySlug, parametros } = useParametros();

  const defaultOrderOption = orders.orderOptions[0];
  const defaultProductGroupOption = "";
  const defaultProductOption = "";
  const defaultNegotiationOption = negotiations.negotiationOptions[0];

  useEffect(() => {
    if(Object.values(objects.grupos)?.length == 0 || Object.values(objects.produtos)?.length == 0){
      setObjects({
        grupos: funilObraGruposProduto?.funilObraGrupoProdutoObjeto ?? {},
        produtos: funilObraProdutos?.funilObraProdutoObjeto ?? {}
      });
    }
  }, [funilObraGruposProduto?.funilObraGrupoProdutoObjeto, funilObraProdutos?.funilObraProdutoObjeto]);

  useEffect(() => {
    props.setOrder(defaultOrderOption);
    props.setProductGroup(defaultProductGroupOption);
    props.setProduct(defaultProductOption);
    props.setNegotiation(defaultNegotiationOption);

    if (typeof setFilters === "function") {
      setFilters({
        ...filters,
        order: defaultOrderOption.value,
        dataNegociacao: defaultNegotiationOption.value,
      });
    }
  }, []);

  const optionGroups = useMemo(() => {
    const options = [...productsFilter];
    options.unshift({
      label: "Todos",
      value: "",
    });
    return options;
  }, [productsFilter]);

  const optionSkus = useMemo(() => {
    if(filters?.grupoProduto){
      const skus = productsFilter.find(e => e.value == filters.grupoProduto)?.skus;
      
      if(skus?.length){
        return [{
            label: "Todos",
            value: ""
          },
          ...skus
        ];
      }
    }

    return [];
  }, [filters]);

  const clearFiltersHandler = () => {
    if (typeof setFilters === "function") {
      setFilters({
        order: defaultOrderOption.value,
        dataNegociacao: defaultNegotiationOption.value,
        grupoProduto: "",
        sku: "",
      });
    }

    funilObraGruposProduto.funilObraGrupoProdutoSelect.upDateDefaultValue("");
    funilObraGruposProduto.funilObraGrupoProdutoSelect.upDateValue("");
    funilObraProdutos.funilObraProdutoSelect.upDateDefaultValue("");
    funilObraProdutos.funilObraProdutoSelect.upDateValue("");

    funilObraGruposProduto.onChangeFunilObraGrupoProduto("");

    props.setProductGroup(defaultProductGroupOption);
    props.setProduct(defaultProductGroupOption);
    props.setOrder(defaultOrderOption);
    props.setNegotiation(defaultNegotiationOption);
  };

  useEffect(() => {
    getBySlug('mostra-sku-funil-obras').then((parametro) => {
      if (parametro?.valor == "sim") setHideSku(false);
      else setHideSku(true);
    });
  }, [parametros]);

  return (
    <main className="funnel-filter">
      <div className="container">
        <div className="filter-row buttons-row">
          {!props.hideFilters ? (
            <Select
              options={orders.orderOptions}
              defaultValue={defaultOrderOption}
              value={props.order}
              onChange={(e) => {
                setFilters({ ...filters, order: e.value });
                props.setOrder(e);
              }}
              label="Ordenar por:"
              name="orderBy"
              variation="compact-inline"
            />
          ) : (
            <div />
          )}

          {props.cliente && (
            <div className="sm:flex buttons-group">
              {!props.workFinished ? (
                <Link to={`${utils.modulePath}/${props.cliente?.id}/mapeamento`} className="button-link mb-2 sm:mb-0">
                <Button className="button">
                  Novo Grupo de Produto
                  <SearchAdd className="icon" size="40" />
                </Button>
              </Link>
              ) : null}             

              <div className="button-link">
                <Button
                  onClick={props.handleShutWork}
                  className="button red mb-2 sm:mb-0"
                  isDisabled={!props.canShutWork}
                >
                  {props.workFinished ? 'Reabrir Obra' : 'Encerrar obra'}
                </Button>
              </div>
            </div>
          )}
        </div>

        {!props.hideSelectFilters && (
          <>
            <hr />

            <div className="filter-row">
              <div className="column">
                <Select
                  options={optionGroups}
                  defaultValue={""}
                  name="funilObraGrupoProdutoId"
                  onChange={(e) => {
                    if (typeof setFilters === "function") setFilters({ ...filters, grupoProduto: e.value, sku: "" });
                    funilObraGruposProduto.onChangeFunilObraGrupoProduto(e);                    
                  }}
                  label="Grupo de Produto:"
                  placeholder="Grupo de Produto"
                  {...funilObraGruposProduto.funilObraGrupoProdutoSelect}
                />
              </div>

              {!hideSku ?
                <div className="column">
                  <Select
                    options={optionSkus}
                    defaultValue={""}
                    name="funilObraProdutoId"
                    onChange={(e) => {
                      if (typeof setFilters === "function") setFilters({ ...filters, sku: e.value });
                      funilObraProdutos.onChangeFunilObraProduto(e);
                    }}
                    label="SKU:"
                    placeholder="SKU"
                    {...funilObraProdutos.funilObraProdutoSelect}
                  />
                </div>
                : null
              }

              <div className="column">
                <Select
                  options={negotiations.negotiationOptions}
                  defaultValue={defaultNegotiationOption}
                  value={props.negotiation}
                  onChange={(e) => {
                    if (typeof setFilters === "function") setFilters({ ...filters, dataNegociacao: e.value });
                    props.setNegotiation(e);
                  }}
                  label="Data de Negociação:"
                  name="orderBy"
                />
              </div>
            </div>

            {!props.hideOrderAndButtons && (
              <div
                onClick={() => {
                  clearFiltersHandler();
                }}
                className="clear-filter cursor-pointer"
              >
                Limpar Filtros
                <CleanFiltersIcon />
              </div>
            )}
          </>
        )}
      </div>
    </main>
  );
};

FunnelFilter.propTypes = FunnelFilterProps;

export default FunnelFilter;
